<template>
  <vx-tooltip :text="$t('save')" position="bottom">
    <vs-button class="text-center saveButton" :id="id" color="success" type="filled" icon-pack="feather" icon="icon-save" size="small" @click.prevent="click"></vs-button>
  </vx-tooltip>
</template>

<script>
export default {
  name: 'SaveButton',
  props: {
    id: {
      required: false
    }
  },
  methods: {
    click () {
      this.$emit('click')
    }
  }
}
</script>

<style scoped>

</style>
